/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

import BufferOptionsItem from 'buffers/BufferOptionsItem';
import {EXTERNAL_FILE_TYPE} from 'constants/PreviewTypeConstants';
import FormInput from 'ui-library/bs/FormInput';
import Label from 'ui-library/bs/Label';
import Tooltip from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import SectionHeader from 'ui-library/menus/SectionHeader';
import {capwords} from 'util/NameUtil';

const DEFAULT_NAME = 'Untitled';
const NO_PREVIEW_TEXT = 'Preview Not Available';

function displayPreviewType(previewType: any): string {
  switch (previewType) {
    case EXTERNAL_FILE_TYPE.IMAGE:
      return 'Image';
    case EXTERNAL_FILE_TYPE.CSV:
      return 'CSV';
    case EXTERNAL_FILE_TYPE.PDF:
      return 'PDF Viewer';
    case EXTERNAL_FILE_TYPE.GOOGLE_DOCS_VIEWER:
      return 'Google Docs Viewer';
    case EXTERNAL_FILE_TYPE.MICROSOFT_OFFICE_ONLINE:
      return 'Microsoft Office Online';
    case EXTERNAL_FILE_TYPE.MOLSTAR_PDB_VIEWER:
    case EXTERNAL_FILE_TYPE.MOLSTAR_PDBQT_VIEWER:
    case EXTERNAL_FILE_TYPE.MOLSTAR_MMCIF_VIEWER:
      return 'Mol* Viewer';
    default:
      return NO_PREVIEW_TEXT;
  }
}

interface Props {
  availablePreviewTypes: Array<string>;
  name?: string;
  previewType?: string | null;
  updateName?: (...args: Array<any>) => any;
  updatePreviewType: (...args: Array<any>) => any;
  generateDownloadUrl: (isPreview: boolean) => Promise<string | null>;
  printOptions: Array<string>;
  printHandler?: (...args: Array<any>) => any;
  isPreviewTransformed?: boolean;
  closeTab?: () => void;
  useAutoHeight?: boolean;
}

class ExternalFileOptions extends React.Component<Props> {
  static displayPreviewType = displayPreviewType;
  handleClick = async (isPreview: boolean): Promise<void> => {
    const url = await this.props.generateDownloadUrl(isPreview);
    if (url == null) {
      return;
    }
    window.open(url, '_blank', 'noopener noreferrer');
  };

  render(): JSX.Element {
    const previewDisabled = this.props.availablePreviewTypes.length === 0;
    const previewButton = (
      <Button
        isDropdown={true}
        disabled={previewDisabled}
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        size={ButtonSize.SMALL}
        text={displayPreviewType(this.props.previewType)}
      />
    );

    // TODO: Stop rendering into buffer-options--builtin, then refactor to use buffers/BufferOptions.js
    return (
      <div
        className={
          this.props.useAutoHeight
            ? 'buffer-options-auto-height buffer-options-container form-inline'
            : 'buffer-options-container form-inline'
        }
      >
        {this.props.updateName != null ? (
          <BufferOptionsItem className="external-file-options-name">
            <Label>Name:</Label>
            <FormInput
              type="text"
              defaultValue={this.props.name}
              onChange={(e: any) => this.props.updateName!(e.target.value || DEFAULT_NAME)}
              placeholder={DEFAULT_NAME}
            />
          </BufferOptionsItem>
        ) : undefined}
        <BufferOptionsItem>
          <div className="btn-group">
            {this.props.isPreviewTransformed ? (
              [
                <Button
                  key="preview-link"
                  buttonStyle={ButtonStyle.TERTIARY_BLUE}
                  size={ButtonSize.SMALL}
                  icon="download"
                  text="Download"
                  onClick={() => this.handleClick(true)}
                />,
                <button
                  key="button"
                  className="btn btn-af-primary btn-xs btn-option dropdown-toggle"
                  data-toggle="dropdown"
                  type="button"
                >
                  <BenchlingIcon icon="chevron-down" />
                </button>,
                <ul className="dropdown-menu" role="menu" key="dropdown-menu">
                  <li>
                    <a
                      download="null"
                      draggable={true}
                      onClick={() => this.handleClick(false)}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Download Original
                    </a>
                  </li>
                </ul>,
              ]
            ) : (
              <Button
                buttonStyle={ButtonStyle.TERTIARY_BLUE}
                size={ButtonSize.SMALL}
                icon="download"
                text="Download"
                onClick={() => this.handleClick(false)}
              />
            )}
          </div>
        </BufferOptionsItem>
        <BufferOptionsItem>
          <Button
            buttonStyle={ButtonStyle.TERTIARY_BLUE}
            size={ButtonSize.SMALL}
            icon="cross-thick"
            text="Close preview"
            onClick={() => {
              this.props.closeTab?.();
            }}
          />
        </BufferOptionsItem>
        <BufferOptionsItem className="buffer-options-item--bannerContainer" />
        <BufferOptionsItem>
          <div className="btn-group">
            {this.props.printOptions.length > 0
              ? [
                  <button
                    key="print-button"
                    className="btn btn-af-default btn-option btn-xs dropdown-toggle"
                    data-toggle="dropdown"
                    type="button"
                  >
                    <BenchlingIcon icon="format-print" />
                    <span className="caret" />
                  </button>,
                  <ul key="print-dropdown" className="dropdown-menu" role="menu">
                    <li>
                      {Array.from(this.props.printOptions).map((option) => (
                        <a onClick={this.props.printHandler!.bind(null, option)} key={option}>
                          {capwords(option)}
                        </a>
                      ))}
                    </li>
                  </ul>,
                ]
              : undefined}
          </div>
          <Dropdown
            menu={
              <Menu dropLeft={true} height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.SMALL}>
                <SectionHeader>Preview with</SectionHeader>
                {this.props.availablePreviewTypes.map((previewType, i) => (
                  <Option
                    key={i}
                    onSelect={() => {
                      this.props.updatePreviewType(previewType);
                    }}
                  >
                    {displayPreviewType(previewType)}
                  </Option>
                ))}
              </Menu>
            }
          >
            {previewDisabled ? <Tooltip title={NO_PREVIEW_TEXT}>{previewButton}</Tooltip> : previewButton}
          </Dropdown>
        </BufferOptionsItem>
      </div>
    );
  }
}

export default ExternalFileOptions;
